import React from 'react'

import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close-arrow.svg'

import * as S from './styles'

type AccordionProps = {
  items: {
    title: string
    content: React.ReactElement
    disabled?: boolean
  }[]
}

const Accordion = ({ items }: AccordionProps) => {
  return (
    <S.Wrapper>
      {items.map((item) => (
        <S.StyledAccordion
          key={item.title}
          elevation={0}
          disabled={item.disabled}
        >
          <S.StyledAccordionSummary
            expandIcon={<CloseIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <S.Title>{item.title}</S.Title>
          </S.StyledAccordionSummary>
          <S.StyledAccordionDetails>{item.content}</S.StyledAccordionDetails>
        </S.StyledAccordion>
      ))}
    </S.Wrapper>
  )
}

export default Accordion
